<script>
  import { currentVendor } from './stores/root.js'
  export let vendorFilter
</script>

<!-- svelte-ignore a11y-no-onchange -->
{#if $currentVendor}
  <select
    name="inventory-filter"
    id="inventory-filter"
    class="form-select"
    bind:value={vendorFilter}
  >
    <option value={null}>Show All Items</option>
    <option value={$currentVendor.id}>Show My Items</option>
  </select>
{/if}
